import { useEffect } from 'react';
import { useErrorGroupsStore } from '../stores/errorGroupsStore';

interface UseErrorGroupsFetchParams {
  searchValue: string;
  currentPage: number;
  pageSize: number;
}

export const useErrorGroupsFetch = ({ searchValue, currentPage, pageSize }: UseErrorGroupsFetchParams) => {
  const getErrorGroups = useErrorGroupsStore((state) => state.getErrorGroups);

  useEffect(() => {
    const fetchErrorGroups = async () => {
      try {
        await getErrorGroups({
          page: currentPage,
          page_size: pageSize,
          search: searchValue || undefined
        });
      } catch (err) {
        console.error('Error fetching error groups:', err);
      }
    };
    void fetchErrorGroups();
  }, [currentPage, pageSize, searchValue, getErrorGroups]);
};
